import { firebaseApp } from "./firebase";
import { getDatabase } from "firebase/database";

export const firebaseDatabase = getDatabase(firebaseApp);